import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { SessionSummaryFieldsFragment } from '../../../../../../../../../../generated/core-api/graphql-react-query';

export default function useUpdateSession() {
  const queryClient = useQueryClient();
  const updateSession = React.useCallback((session: SessionSummaryFieldsFragment) => {
    queryClient.invalidateQueries(['listSessions.infinite']);
    queryClient.setQueryData(['getSessionDetails', { input: { id: session.id } }], {
      getSession: session,
    });
  }, []);

  return updateSession;
}
